



























export default {
  name: 'ExpertFeedbacksModerationItem'

  methods:
    onClick: ->
      if @item.in_feedbacks
        url = @item.remove_from_expert_profile_url
        method = 'DELETE'
      else
        url = @item.add_to_expert_profile_url
        method = 'POST'
      return unless !!url
      $.ajax({
        url: url,
        method: method,
        dataType: 'json',
        success: @onClickSuccess
      })

    onClickSuccess: (data) ->
      if data.success
        @$emit('onClick', { id: @item.id, context: data.context })

  computed:
    buttonText: ->
      if @item.in_feedbacks
        @$i18n('expert_feedback.remove_button')
      else
        @$i18n('expert_feedback.add_button')

  props:
    item:
      type: Object
      default: ->
        {}
    index: Number
    onLoadPage: Boolean
}
